<template>
    <div class="article-list">
        <div class="article-container">
            <div class="article-title">
                <div class="name-wrapper">
                    <h3>문제 생성</h3>
                </div>
            </div>
            <div class="article-demonstrate">
                <li class="demonstration">문제를 만들어보세요</li>
            </div>
            <el-form ref="form" style="text-align: left" :inline="true" size="small" :model="form" label-width="50px">
                <el-form-item label="학년">
                    <el-select v-model="grade" style="width: 60px;" @change="change_chapter_option">
                        <el-option
                                v-for="item in [1,2,3,4,5,6]"
                                :key="item + 'A'"
                                :label="item"
                                :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="학기">
                    <el-select v-model="semester" style="width: 60px;" @change="change_chapter_option">
                        <el-option
                                v-for="item in [1,2]"
                                :key="item + 'B'"
                                :label="item"
                                :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="단원">
                    <el-select v-model="chapter_id">
                        <el-option
                                v-for="item in chapter_options"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="W/H">
                    <el-input v-model="width" style="width:60px"></el-input>
                    <el-input v-model="height" style="width:60px"></el-input>
                </el-form-item>
                <el-form-item label="">
                    <el-button type="warning" size="mini" @click="testProblem()">샘플</el-button>
                </el-form-item>
                <el-form-item label="">
                    <el-button type="success" size="mini" @click="submitProblem()">완료</el-button>
                </el-form-item>
            </el-form>
            <el-form style="text-align: left;" :inline="true">
                <el-form-item label="제목" size="small" label-width="50px">
                    <el-input placeholder="문제 제목을 입력하세요." v-model="name" style="width: 240px;"></el-input>
                </el-form-item>
                <el-form-item label="문제수" size="small" label-width="60px">
                    <el-input placeholder="문제수" v-model="num" style="width: 80px;"></el-input>
                </el-form-item>
                <el-form-item label="" size="small" label-width="0px">
                    <el-button type="info" size="mini" @click="alignHorizontal()">상단맞춤</el-button>
                    <el-button type="plain" size="mini" @click="alignVertical()">좌우간격</el-button>
                    <el-button type="plain" size="mini" @click="alignVertical2()">상하간격</el-button>
                    <el-button type="warning" size="mini" @click="duplicate()">문제복제</el-button>
                </el-form-item>
                <el-form-item label="설명" size="small" label-width="50px">
                    <el-input placeholder="다음을 계산해서 기약분수로 나타내세요." v-model="description" style="width: 450px"></el-input>
                </el-form-item>
                <el-form-item label="첫 문항 답지">
                    <el-select v-model="first_answer" size="small">
                        <el-option
                                label="O"
                                :value="true">
                        </el-option>
                        <el-option
                                label="X"
                                :value="false">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div id="app" style="position: absolute; border: 1px solid #8c939d; width: 844px; height: 400px; text-align: left;">
                <VueDragResize v-for="(rect, index) in rects.filter(r => r.type !== 'var')" @deactivated="onDeactivated"
                   :key="index"
                   :w="rect.width"
                   :h="rect.height"
                   :x="rect.left"
                   :y="rect.top"
                   :parentW="listWidth"
                   :parentH="listHeight"
                   :axis="rect.axis"
                   :isActive="rect.active"
                   :minw="rect.minw"
                   :minh="rect.minh"
                   :isDraggable="rect.draggable"
                   :isResizable="rect.resizable"
                   :parentLimitation="rect.parentLim"
                   :snapToGrid="rect.snapToGrid"
                   :aspectRatio="rect.aspectRatio"
                   :z="rect.zIndex"
                   @click.native="clicked(rect)"
                   v-on:dragging="changePosition($event, rect)"
                   v-on:resizing="changeSize($event, rect)">
                    <div v-if="rect.type === 'text' || rect.type === 'num'" class="filler" :style="'color:'+rect.foreColor+'backgroundColor:'+rect.color+';text-align: '+rect.alignment+';font-size:'+rect.size+'px;font-weight:'+rect.border+';border:'+rect.border_weight+'px solid ' + rect.border_color">
                        <span style="cursor: default;">{{rect.text}}</span>
                    </div>
                    <hr v-else-if="rect.type === 'line' && rect.direct === 'horizontal'" :style="'position:absolute; display: inline-block;width:'+rect.size+`px;border-top: ${rect.thickness}px ${rect.style} ${rect.color};`">
                    <div v-else-if="rect.type === 'line' && rect.direct === 'vertical'" :style="'position:absolute; display: inline-block;height:'+rect.size+`px;border-left: ${rect.thickness}px ${rect.style} ${rect.color};`"></div>
                </VueDragResize>
            </div>
            <el-table-draggable>
                <el-table
                  :data="rects"
                  style="clear: both; margin-top: 420px;width: 100%"
                  size="small"
                  :border="true"
                  empty-text="대상이 없습니다."
                  cell-style="cursor: pointer">
                <el-table-column
                        label="번호"
                        width="46">
                    <template slot-scope="scope">
                        {{scope.$index+1}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="명칭"
                        width="130">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.label" size="mini"></el-input>
                    </template>
                </el-table-column>
                <el-table-column
                        label="크기"
                        width="70">
                    <template slot-scope="scope" v-if="scope.row.type !== 'var'">
                        <el-input v-model="scope.row.size" size="mini"></el-input>
                    </template>
                </el-table-column>
                <el-table-column
                        label="글자색"
                        width="113">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.foreColor" size="mini"></el-input>
                    </template>
                </el-table-column>
                <el-table-column
                        label="타입"
                        width="70">
                    <template slot-scope="scope">
                        <span v-if="scope.row.type === 'num'">번호</span>
                        <span v-else-if="scope.row.type === 'var'">변수</span>
                        <span v-else-if="scope.row.type === 'text'">텍스트</span>
                        <span v-else-if="scope.row.type === 'line'">선분</span>
                    </template>
                </el-table-column>
                <el-table-column
                        label="값"
                        width="138">
                    <template slot-scope="scope" v-if="scope.row.type === 'text' || scope.row.type === 'var'">
                        <el-input v-model="scope.row.text" size="mini"></el-input>
                    </template>
                </el-table-column>
                <el-table-column
                        label="상단"
                        width="73">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.top" size="mini"></el-input>
                    </template>
                </el-table-column>
                <el-table-column
                        label="좌측"
                        width="73">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.left" size="mini"></el-input>
                    </template>
                </el-table-column>
                <el-table-column
                        label="수정"
                        width="130">
                    <template slot-scope="scope">
                        <el-button type="warning" size="mini" @click="modifyRect(scope.row.id, scope.$index)" icon="el-icon-edit" circle></el-button>
                        <el-button type="danger" size="mini" @click="deleteRect(scope.$index)" icon="el-icon-delete" circle></el-button>
                        <el-button type="success" size="mini" @click="duplicateRect(scope.$index)" icon="el-icon-document-copy" circle></el-button>
                    </template>
                </el-table-column>
                    <!--
                <el-table-column
                        label="정렬"
                        width="78">
                    <template slot-scope="scope">
                        <i class="el-icon-caret-top" @click="changeOrder(scope.$index, 'up')"></i>
                        <i class="el-icon-caret-bottom" @click="changeOrder(scope.$index, 'down')"></i>
                    </template>
                </el-table-column>
                -->
            </el-table>
            </el-table-draggable>
            <div style="width: 100%; text-align: right; margin-top: 10px;">
                <el-button type="primary" size="mini" @click="makeDialog()">추가</el-button>
            </div>
        </div>
        <el-dialog
                title="샘플"
                :visible.sync="sampleDialogVisible"
                :width="`${parseInt(width)+100}px`"
                :height="`${parseInt(height)+500}px`">
            <Question :width="width" :height="height" :rects="rects"></Question>
        </el-dialog>
        <el-dialog
                title="항목추가"
                :visible.sync="dialogVisible"
                width="30%"
                :before-close="handleClose">
            <el-tabs v-model="makeTab" style="text-align: right;" @tab-click="makeDialog">
                <el-tab-pane label="텍스트" name="text">
                    <el-form ref="form" size="small" :model="form" style="text-align: left;" label-width="120px">
                        <el-form-item label="명칭">
                            <el-input v-model="form.label"></el-input>
                        </el-form-item>
                        <el-form-item label="텍스트">
                            <el-input v-model="form.text"></el-input>
                            <span>변수는 대괄호로 작성하세요. (예: [a])</span>
                        </el-form-item>
                        <el-form-item label="폰트사이즈">
                            <el-input v-model="form.size"></el-input>
                        </el-form-item>
                        <el-form-item label="가로정렬">
                            <el-select v-model="form.alignment" placeholder="정렬선택">
                                <el-option
                                        label="왼쪽"
                                        value="left">
                                </el-option>
                                <el-option
                                        label="가운데"
                                        value="center">
                                </el-option>
                                <el-option
                                        label="오른쪽"
                                        value="right">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="좌측의존성">
                            <el-select v-model="form.left_depend" placeholder="없음">
                                <el-option
                                        v-for="rect in rects.filter(rec => rec.type !== 'var')"
                                        :key="rect.label"
                                        :label="rect.label"
                                        :value="rect.label">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="표현 색상">
                            <el-input v-model="form.color"></el-input>
                        </el-form-item>
                        <el-form-item label="글자색">
                            <el-input v-model="form.foreColor"></el-input>
                        </el-form-item>
                        <el-form-item label="텍스트 굵기">
                            <el-select v-model="form.weight" placeholder="굵기">
                                <el-option
                                        label="일반"
                                        value="normal">
                                </el-option>
                                <el-option
                                        label="굵게"
                                        value="bold">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="선 색상">
                            <el-input v-model="form.border_color"></el-input>
                        </el-form-item>
                        <el-form-item label="선 굵기">
                            <el-select v-model="form.border_weight" placeholder="굵기">
                                <el-option
                                        label="없음"
                                        :value="0">
                                </el-option>
                                <el-option
                                        label="약하게"
                                        :value="1">
                                </el-option>
                                <el-option
                                        label="중간"
                                        :value="2">
                                </el-option>
                                <el-option
                                        label="진하게"
                                        :value="3">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="답안">
                            <el-select v-model="form.answer" placeholder="답안여부">
                                <el-option
                                        label="답안시에만"
                                        :value="true">
                                </el-option>
                                <el-option
                                        label="일반"
                                        :value="false">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                    <el-button type="primary" @click="makeConfirm('text')">완료</el-button>
                </el-tab-pane>
                <el-tab-pane label="변수" name="var">
                    <el-form ref="form" size="small" :model="form" style="text-align: left;" label-width="120px">
                        <el-form-item label="명칭">
                            <el-input v-model="form.label"></el-input>
                        </el-form-item>
                        <el-form-item label="함수">
                            <el-select v-model="form.function">
                                <el-option value="" label="수식"></el-option>
                                <el-option value="random_int" label="정수랜덤"></el-option>
                                <el-option value="random_int2" label="정수랜덤(제외)"></el-option>
                                <el-option value="random_int_list" label="정수랜덤(리스트)"></el-option>
                                <el-option value="division_random" label="약수랜덤"></el-option>
                                <el-option value="multiply_random" label="배수랜덤"></el-option>
                                <el-option value="floor" label="소수점버림"></el-option>
                                <el-option value="ceil" label="소수점올림"></el-option>
                                <el-option value="round" label="소수점반올림"></el-option>
                                <el-option value="gcd" label="최대공약수"></el-option>
                                <el-option value="lcm" label="최소공배수"></el-option>
                                <el-option value="condition" label="조건"></el-option>
                                <el-option value="division" label="약수"></el-option>
                                <el-option value="multiply" label="배수"></el-option>
                                <el-option value="primefactor" label="소인수"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="인자">
                            <el-input v-model="form.text"></el-input>
                            <span>(예: 1&ensp;1,3&ensp;1.3,4.8&ensp;[a]&ensp;[a],[b])</span>
                        </el-form-item>
                    </el-form>
                    <el-button type="primary" @click="makeConfirm('var')">완료</el-button>
                </el-tab-pane>
                <el-tab-pane label="선" name="line">
                    <el-form ref="form" size="small" :model="form" style="text-align: left;" label-width="120px">
                        <el-form-item label="명칭">
                            <el-input v-model="form.label"></el-input>
                        </el-form-item>
                        <el-form-item label="길이">
                            <el-input v-model="form.size"></el-input>
                        </el-form-item>
                        <el-form-item label="색상">
                            <el-input v-model="form.color"></el-input>
                        </el-form-item>
                        <el-form-item label="두께">
                            <el-input v-model="form.thickness"></el-input>
                        </el-form-item>
                        <el-form-item label="스타일">
                            <el-select v-model="form.style">
                                <el-option
                                        label="실선"
                                        value="solid">
                                </el-option>
                                <el-option
                                        label="점선"
                                        value="dotted">
                                </el-option>
                                <el-option
                                        label="긴점선"
                                        value="dashed">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="방향">
                            <el-select v-model="form.direct">
                                <el-option
                                        label="가로"
                                        value="horizontal">
                                </el-option>
                                <el-option
                                        label="세로"
                                        value="vertical">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                    <el-button type="primary" @click="makeConfirm('line')">완료</el-button>
                </el-tab-pane>
                <el-tab-pane label="문제번호" name="num">
                    <el-form ref="form" size="small" :model="form" style="text-align: left;" label-width="120px">
                        <el-form-item label="크기">
                            <el-input v-model="form.size"></el-input>
                        </el-form-item>
                    </el-form>
                    <el-button type="primary" @click="makeConfirm('var')">완료</el-button>
                </el-tab-pane>
            </el-tabs>
            <span slot="footer" class="dialog-footer">
            </span>
        </el-dialog>
        <el-dialog
                title="문제복제"
                width="710px"
                :visible.sync="duplicateForm">
            <el-table
                    :data="questionData"
                    style="width: 100%"
                    size="small"
                    empty-text="문제가 없습니다."
                    @cell-click="duplicateQuestion"
                    cell-style="cursor: pointer">
                <el-table-column
                        label="학년"
                        prop="grade"
                        width="50"
                        align="left"
                        header-align="center">
                </el-table-column>
                <el-table-column
                        label="학기"
                        prop="semester"
                        width="50"
                        align="left"
                        header-align="center">
                </el-table-column>
                <el-table-column
                        prop="name"
                        label="대단원"
                        width="230"
                        header-align="center">
                </el-table-column>
                <el-table-column
                        prop="questionName"
                        label="소단원"
                        width="225"
                        header-align="center">
                </el-table-column>
                <el-table-column
                        label="작성일"
                        width="90"
                        align="center">
                    <template slot-scope="scope">
                        {{scope.row.date.split('T')[0]}}
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>

<script>
    import VueDragResize from 'vue-drag-resize'
    import Question from './Question'
    import ElTableDraggable from 'element-ui-el-table-draggable';
    export default {
        name: "Maker",
        components: {
            VueDragResize,
            Question,
            ElTableDraggable
        },
        data() {
            return {
                questionData: [],
                duplicateForm: false,
                dialogVisible: false,
                sampleDialogVisible: false,
                makeTab: 'text',
                name: '',
                description: '',
                first_answer: false,
                form: {
                    size: 20,
                    text: '',
                    alignment: 'left',
                    vertical: 'left',
                    color: '#DDDDDD',
                    label: '',
                    left_depend: '',
                    function: '',
                    weight: 'bold',
                    border_weight: 0,
                    border_color: '#000000',
                    thickness: 1,
                    direct: 'horizontal',
                    style: 'solid',
                    answer: false
                },
                datas: [],
                grade: 1,
                semester: 1,
                num: 20,
                chapter_id: 0,
                chapter_options: [],
                chapter_data_all: [],
                width: 200,
                height: 100,
                dialogType: 'create',
                actived: [],
                rects: [
                    {
                        'label': '문제번호',
                        'type': 'num',
                        'text': '1.',
                        'size': 20,
                        'thickness': 1,
                        'style': 'solid',
                        'direct': 'horizontal',
                        'width': 30,
                        'height': 28,
                        'top': 10,
                        'left': 10,
                        'draggable': true,
                        'resizable': true,
                        'minw': 10,
                        'minh': 0,
                        'axis': 'both',
                        'parentLim': true,
                        'snapToGrid': false,
                        'left_depend': '',
                        'aspectRatio': false,
                        'zIndex': 1,
                        'function': '',
                        'color': '#50BCDF',
                        'active': false,
                        'border': 'bold',
                        'border_weight': 0,
                        'border_color': '#000000',
                        'answer': false
                    }
                ]
            }
        },
        created() {
            this.keyup_event();
            this.$http.get(`/api/chapters/list`)
                .then((result) => {
                    this.chapter_data_all = result.data
                    this.change_chapter_option()
                });
            const id = this.$route.query.id;
            if (id !== undefined) {
                this.$http.get(`/api/questions/get?id=${id}`)
                    .then((result) => {
                        this.name = result.data.questionName

                        let my_data = JSON.parse(result.data.data)
                        console.log(my_data)
                        if (result.data.description === undefined) result.data.description = ''
                        if (result.data.first_answer === undefined) result.data.first_answer = true
                        this.description = my_data.description
                        this.first_answer = my_data.first_answer
                        this.width = my_data.width
                        this.height = my_data.height
                        this.num = my_data.num
                        this.rects = my_data.datas
                        this.grade = my_data.grade
                        this.semester = my_data.semester

                        this.change_chapter_option();
                        this.chapter_id = result.data.chapter_id
                    });
            }
        },
        mounted() {
        },
        methods: {
            keyup_event() {
                let _self = this
                window.addEventListener('keyup', function (e) {
                    e.preventDefault();
                    _self.actived.filter((v, w) => _self.actived.indexOf(v) === w).forEach(a => {
                        switch (e.key) {
                            case 'ArrowUp':
                                a.top--;
                                break;
                            case 'ArrowDown':
                                a.top++;
                                break;
                            case 'ArrowLeft':
                                a.left--;
                                break;
                            case 'ArrowRight':
                                a.left++;
                                break;
                        }
                    });
                })
                window.addEventListener('keydown', function (e) {
                    if (e.key.includes('Arrow'))
                        e.preventDefault();
                })
            },
            onDeactivated() {
                let _self = this
                setTimeout(function () {
                    _self.actived = []
                }, 300);
            },
            clicked(rect){
                if (!(rect in this.actived))
                    this.actived.push(rect);
            },
            /*
            changeOrder(idx, t) {
                if (t === 'up') {
                    let tmp = this.rects[idx];
                    this.rects[idx] = this.rects[idx - 1];
                    this.rects[idx - 1] = tmp;
                    console.log(this.rects[idx], this.rects[idx-1])
                } else {
                    let tmp = this.rects[idx];
                    this.rects[idx] = this.rects[idx + 1];
                    this.rects[idx + 1] = tmp;
                }
                this.rects.reverse().reverse()
            },*/
            modifyRect(id, idx) {
                this.form = this.rects[idx]
                this.makeTab = this.rects[idx].type
                this.dialogType = 'modify'
                this.dialogVisible = true;
            },
            deleteRect(id) {
                this.rects.splice(id, 1)
            },
            duplicateRect(id) {
                this.rects.splice(id, 0, JSON.parse(JSON.stringify(this.rects[id])));
            },
            makeDialog(type) {
                this.form = {
                    size: 20,
                    text: '',
                    alignment: 'left',
                    vertical: 'left',
                    color: '#DDDDDD',
                    label: '',
                    left_depend: '',
                    function: '',
                    weight: 'bold',
                    border_weight: 0,
                    border_color: '#000000',
                    thickness: 1,
                    direct: 'horizontal',
                    style: 'solid',
                    answer: false
                }
                if (type !== undefined && type.name === 'line') this.form.color = '#000000';
                this.dialogType = 'create'
                this.dialogVisible = true;
            },
            makeConfirm(type) {
                if (this.dialogType === 'modify') {
                    this.$message({
                        message: '수정되었습니다.',
                        type: 'success'
                    });
                    this.dialogVisible = false
                    return
                }
                let is_label_exist = this.rects.filter(rec => rec.label === this.form.label)
                if (is_label_exist.length > 0) {
                    this.$message({
                        message: '이미 존재하는 명칭입니다.',
                        type: 'warning'
                    });
                    return;
                }
                let color = this.form.color
                let width = 40, height = 40
                switch (type) {
                    case 'line':
                        if (this.form.direct === 'horizontal') width = this.form.size
                        else if (this.form.direct === 'vertical') height = this.form.size
                    // eslint-disable-next-line no-fallthrough
                    case 'text':
                        if (this.form.answer) color = '#ff9f40'
                        this.rects.push(
                            {
                                'label': this.form.label,
                                'text': this.form.text,
                                'type': type,
                                'width': width,
                                'height': height,
                                'top': 10,
                                'left': 10,
                                'size': this.form.size,
                                'draggable': true,
                                'resizable': true,
                                'minw': 10,
                                'minh': 0,
                                'axis': 'both',
                                'left_depend': '',
                                'function': '',
                                'parentLim': true,
                                'snapToGrid': false,
                                'aspectRatio': false,
                                'zIndex': 1,
                                'style': this.form.style,
                                'thickness': this.form.thickness,
                                'direct': this.form.direct,
                                'color': color,
                                'active': false,
                                'border': this.form.weight,
                                'answer': this.form.answer
                            })
                        break
                    case 'var':
                        this.rects.push(
                            {
                                'label': this.form.label,
                                'text': this.form.text,
                                'type': 'var',
                                'width': 40,
                                'height': 30,
                                'top': 10,
                                'left': 10,
                                'draggable': true,
                                'resizable': true,
                                'minw': 10,
                                'minh': 1,
                                'axis': 'both',
                                'function': this.form.function,
                                'left_depend': this.form.left_depend,
                                'parentLim': true,
                                'snapToGrid': false,
                                'aspectRatio': false,
                                'zIndex': 1,
                                'color': this.form.color,
                                'active': false
                            })
                        break
                }
                this.$message({
                    message: '생성되었습니다.',
                    type: 'success'
                });
            },
            testProblem() {
                let tmp = JSON.stringify(this.rects)
                this.rects = JSON.parse(tmp)
                this.sampleDialogVisible = true
            },
            alignHorizontal () {
                let top = undefined;
                for (let x of this.actived) {
                    for (let y of this.rects) {
                        if (y.label === x.label) {
                            if (top === undefined) top = y.top;
                            y.top = top;
                        }
                    }
                }
            },
            alignVertical () {
                if (this.actived.length <= 1) return
                this.actived.sort((a, b) => {
                    return a.left - b.left
                })
                let n = 0
                for (let x of this.actived) {
                    x.left = this.actived[0].left + n * (this.actived[1].left - this.actived[0].left)
                    n += 1
                }
                this.actived = []
            },
            alignVertical2 () {
                if (this.actived.length <= 1) return
                this.actived.sort((a, b) => {
                    return a.top - b.top
                })
                let n = 0
                for (let x of this.actived) {
                    x.top = this.actived[0].top + n * (this.actived[1].top - this.actived[0].top)
                    n += 1
                }
                this.actived = []
            },
            async duplicate () {
                this.questionData = (await this.$http.get(`/api/questions/list?page=0`)).data.data
                console.log(this.questionData)
                this.duplicateForm = true
            },
            async submitProblem() {
                for (let r of this.rects) {
                    let is_label_exist = this.rects.filter(rec => rec.label === r.label)
                    if (is_label_exist.length > 1) {
                        this.$message({
                            message: '먼저 중복 명칭을 제거하세요.',
                            type: 'warning'
                        });
                        return;
                    }
                }

                const id = this.$route.query.id;
                console.log(id)
                if (id === undefined) {
                    await this.$http.post(`/api/questions/insert`, {
                        grade: this.grade,
                        semester: this.semester,
                        chapter_id: this.chapter_id,
                        first_answer: this.first_answer,
                        description: this.description,
                        name: this.name,
                        num: this.num,
                        datas: this.rects,
                        width: this.width,
                        height: this.height
                    })
                    this.$message({
                        message: '문제가 생성되었습니다.',
                        type: 'success'
                    });
                } else {
                    await this.$http.post(`/api/questions/update`, {
                        grade: this.grade,
                        semester: this.semester,
                        chapter_id: this.chapter_id,
                        first_answer: this.first_answer,
                        description: this.description,
                        name: this.name,
                        num: this.num,
                        datas: this.rects,
                        width: this.width,
                        height: this.height,
                        id: id
                    })
                    this.$message({
                        message: '문제가 수정되었습니다.',
                        type: 'success'
                    });
                }
                this.$router.push('/maker/list')
            },
            change_chapter_option() {
                let first = true
                this.chapter_options = []
                for(let x of this.chapter_data_all) {
                    if (this.grade == x.grade && this.semester == x.semester) {
                        if (first) {
                            this.chapter_id = x.id
                            first = false
                        }
                        this.chapter_options.push(x)
                    }
                }
            },
            changeSize(newRect, rect) {
                rect.top = newRect.top;
                rect.left = newRect.left;
                rect.width = newRect.width;
                rect.height = newRect.height;
                if (rect.type === 'line' && rect.direct === 'horizontal')
                    rect.size = rect.width
                else if (rect.type === 'line' && rect.direct === 'vertical')
                    rect.size = rect.height
            },
            changePosition(newRect, rect) {
                rect.top = newRect.top;
                rect.left = newRect.left;
                rect.width = newRect.width;
                rect.height = newRect.height;
            },
            fetchData() {
            },
            duplicateQuestion(n) {
                this.$http.get(`/api/questions/get?id=${n.id}`)
                    .then((result) => {
                        this.name = result.data.questionName
                        this.chapter_id = result.data.chapter_id

                        let my_data = JSON.parse(result.data.data)
                        if (my_data.description === undefined) my_data.description = ''
                        if (my_data.first_answer === undefined) my_data.first_answer = false
                        this.first_answer = my_data.first_answer
                        this.description = my_data.description
                        this.width = my_data.width
                        this.height = my_data.height
                        this.num = my_data.num
                        this.rects = my_data.datas
                        this.grade = my_data.grade
                        this.semester = my_data.semester
                    });
            }
        },
        watch: {
        }
    }
</script>

<style>
    .filler {
        width: 100%;
        height: 100%;
        display: inline-block;
        position: absolute;
    }
    .article-list {
        width: 100%;
        text-align: center;
        display: inline-block;
        box-sizing: border-box;
        padding: 15px;
    }
    .article-container {
        width: 100%;
        text-align: center;
        margin: 0 auto;
        display: inline-block;
    }
    .article-title {
        width: 100%;
        border-bottom: 2px solid #bcbcbc;
        margin: 0 auto;
        display: inline-block;
    }
    .name-wrapper {
        float: left;
        line-height: 22px;
        letter-spacing: -1px;
        display: inline-block;
    }
    .name-wrapper > h3 {
        font-family: 나눔고딕,NanumGothic,system,sans-serif;
        font-size: 18px;
        font-weight: 600;
        color: #333;
    }
    .article-demonstrate {
        width: 100%;
        margin: 0 auto;
        display: inline-block;
    }
    .demonstration {
        display: list-item;
        text-align: left;
        margin-top: 10px;
        margin-bottom: 4px;
        color: #888;
        font-size: 12px;
        line-height: 15px;
        letter-spacing: -.3px;
        font-family: 나눔고딕,NanumGothic,system,sans-serif;
        list-style: none;
        float: left;
    }
    .article-table {
        width: 100%;
        margin: 30px auto;
        display: inline-block;
    }
    .pagination{
        display: inline-block;
        width: 880px;
    }
    .astext {
        background: none;
        border: none;
        margin: 0;
        padding: 0;
        cursor: pointer;
    }
    .write-buttons {
        width: 100%;
        margin: 0 auto;
        display: inline-block;
    }
    .write-buttons > button {
        float: right;
    }
</style>